export const LLM_SETTINGS_SLICE_NAME = 'llmSettings';
